import { infiniteQueryOptions } from '@tanstack/react-query'

import type { OrdersListParams } from '../types/orders.types'
import { ordersApi, type OrdersPage } from './ordersApi'

const ORDERS_PAGE_SIZE = 20
const FIRST_PAGE = 0

const getNextPageParam = (lastPage: OrdersPage) => lastPage.nextPage ?? null

export const ordersQueries = {
  all: () => ['orders'] as const,
  lists: () => [...ordersQueries.all(), 'list'] as const,
  list: (params: OrdersListParams) =>
    infiniteQueryOptions({
      queryKey: [...ordersQueries.lists(), params],
      queryFn: ({ pageParam, signal }) =>
        ordersApi.getOrders(
          { ...params, page: pageParam, pageSize: ORDERS_PAGE_SIZE },
          { signal }
        ),
      initialPageParam: FIRST_PAGE,
      getNextPageParam,
    }),
}
